import React from 'react';
import BackButton from '../components/BackButton';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';

export default function Cancelacion() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto px-4 md:px-6 max-w-3xl py-12">
        <BackButton />
        <h1 className="text-4xl font-heading font-bold text-[#134168] mb-2">{t('legal.cancelTitle')}</h1>
        <p className="text-sm text-gray-400 mb-8">{t('legal.lastUpdatedMay')}</p>

        <div className="bg-white rounded-3xl p-8 shadow-sm space-y-6 text-gray-700 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-4">{t('legal.cancelRefundsTable')}</h2>
            <div className="space-y-3">
              <div className="flex items-center gap-4 p-4 bg-green-50 border border-green-200 rounded-2xl">
                <span className="text-2xl">✅</span>
                <div>
                  <p className="font-bold text-green-800">{t('legal.cancel100Title')}</p>
                  <p className="text-green-700 text-xs mt-0.5">{t('legal.cancel100Desc')}</p>
                </div>
              </div>
              <div className="flex items-center gap-4 p-4 bg-yellow-50 border border-yellow-200 rounded-2xl">
                <span className="text-2xl">⚠️</span>
                <div>
                  <p className="font-bold text-yellow-800">{t('legal.cancel50Title')}</p>
                  <p className="text-yellow-700 text-xs mt-0.5">{t('legal.cancel50Desc')}</p>
                </div>
              </div>
              <div className="flex items-center gap-4 p-4 bg-red-50 border border-red-200 rounded-2xl">
                <span className="text-2xl">❌</span>
                <div>
                  <p className="font-bold text-red-800">{t('legal.cancel0Title')}</p>
                  <p className="text-red-700 text-xs mt-0.5">{t('legal.cancel0Desc')}</p>
                </div>
              </div>
            </div>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.cancelProcessTitle')}</h2>
            <p>{t('legal.cancelProcessText')}</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.cancelByProviderTitle')}</h2>
            <p>{t('legal.cancelByProviderText')}</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.cancelPendingTitle')}</h2>
            <p>{t('legal.cancelPendingText')}</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.cancelDisputesTitle')}</h2>
            <p>{t('legal.cancelDisputesText')}</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.cancelContactTitle')}</h2>
            <p>{t('legal.cancelContactText')} <a href="mailto:info@redmobility.com" className="text-[#134168] hover:underline">info@redmobility.com</a> · WhatsApp <a href="https://wa.me/18095550100" className="text-[#134168] hover:underline">+1-809-555-0100</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
